// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-0b84086f] {\n  color: gray;\n  font-weight: 300;\n}\n.wrapper-image-preview[data-v-0b84086f] {\n  text-align: center;\n  min-height: 300px;\n  background-color: #efefef;\n}\n.image-preview[data-v-0b84086f] {\n  padding: 12px;\n  min-height: 300px;\n  background-color: #eaeaea;\n}\n.image-preview[data-v-0b84086f],\ninput[type=file][data-v-0b84086f] {\n  min-width: 420px;\n}", ""]);
// Exports
module.exports = exports;
